import cookie from 'browser-cookies';
import { StateType } from '@central-products/interface-session-service';
import { subscribe, unsubscribe } from '@wh/message-bus';
import { isDeviceNative } from '../session/deviceDetection';

const isUserInAudience = (audienceName) => {
  const data = window.utag.data;
  const audienceKeys = Object.keys(data).filter((k) => k.startsWith('va.audiences.'));
  return !!audienceKeys.find((k) => data[k].trim() === audienceName);
};

const setLivepersonCookie = (cookieName, cookieValue, expiresInMinutes, custhelpSetCookieUrl) => {
  const expiryDateInMs = new Date().getTime() + expiresInMinutes * 60 * 1000;
  const expiryDateInSeconds = Math.floor(expiryDateInMs / 1000);
  const expiryDate = new Date(expiryDateInMs);
  cookie.set(cookieName, String(cookieValue), {
    expires: expiryDate,
    domain: document.location.hostname.substr(document.location.hostname.indexOf('.')),
  });

  const iframe = document.createElement('iframe');
  const queryParams = `?name=${cookieName}&value=${cookieValue}&expiresAt=${expiryDateInSeconds}`;
  iframe.src = custhelpSetCookieUrl + queryParams;
  iframe.style.display = 'none';
  iframe.onload = () => {
    iframe.parentNode.removeChild(iframe);
  };
  document.body.appendChild(iframe);
};

export const initLivepersonCookie = ({
  audienceName,
  cookieName,
  cookieValue,
  custhelpSetCookieUrl,
  expiresInMinutes,
  utagCheckTimeInMillis,
  utagCheckTimes,
  forceDisabledCookieName,
}) => {
  const subscrId = subscribe({
    topic: 'wh.common.event.sessionService.state.changed',
    callback: ({ data }) => {
      if (data.state !== StateType.SESSION_EXISTS || isDeviceNative()) {
        return;
      }
      unsubscribe(subscrId);

      let counter = 0;
      const interval = setInterval(() => {
        counter++;

        const forceDisabled = cookie.get(forceDisabledCookieName) === 'true';
        if (forceDisabled) {
          setLivepersonCookie(cookieName, !cookieValue, expiresInMinutes, custhelpSetCookieUrl);
          clearInterval(interval);
          return;
        }

        if (counter === parseInt(utagCheckTimes)) {
          clearInterval(interval);
        }

        if (window.utag) {
          if (isUserInAudience(audienceName)) {
            setLivepersonCookie(cookieName, cookieValue, expiresInMinutes, custhelpSetCookieUrl);
          }
          clearInterval(interval);
        }
      }, utagCheckTimeInMillis);
    },
  });
};
